
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/view/[code]",
      function () {
        return require("private-next-pages/parts/view/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/view/[code]"])
      });
    }
  